import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import { Dropdown, Button, Header, Modal, Icon } from "semantic-ui-react";
import AddressTab from "../../relations/parts/AddressTab"

class AddressSelector extends Component {
    constructor() {
        super();
        this.state = {
            modalOpen: false
        }
    }

    onModalClose = () => {
        this.setState({
            modalOpen: false
        });
    }

    onModalOpen = () => {
        this.setState({
            modalOpen: true
        });
    }

    render() {
        const {name, selectedValues, onValueChange, addresses, relationId} = this.props;
        const options = [];
        _.each(addresses, address => {
            options.push({
                key: address.id,
                text: address.label,
                value: _.toString(address.id),
                content:   <Header as='h4'>
                    {address.label}
                    <Header.Subheader>
                        {address.company}, {address.address_1} {address.address_2 ? `${address.address_2}, ` : null}
                        {address.city ? `${address.city}, ` : null}
                        {address.state ? `${address.state}, ` : null}
                        {address.postcode ? `${address.postcode}` : null}
                    </Header.Subheader>
                </Header>
            })
        })
        return (
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <label style={{
                        display: 'block',
                        margin: '0 0 .28571429rem 0',
                        color: 'rgba(0,0,0,.87)',
                        fontSize: '.92857143em',
                        fontWeight: 700,
                        textTransform: 'none'
                    }}>{name} &nbsp;&nbsp;<a href="javascript:;" onClick={() => this.onModalOpen()}>
                        <Icon name='edit outline' />
                    </a></label>
                    <Dropdown 
                        value={selectedValues}
                        onChange={(e, data) => onValueChange(e, data)}
                        fluid selection options={options} search/>
                </div>
                <Modal
                    open={this.state.modalOpen}
                    closeOnEscape={true}
                    closeOnDimmerClick={false}
                    onClose={() => {this.onModalClose()}}
                    size='large'
                >
                    <Modal.Header>
                        Manage Address
                        <div style={{float: 'right'}}>
                            <Button size='mini' onClick={() => {this.onModalClose()}} color="red" floated='left'>
                                Close
                            </Button>
                        </div>    
                    </Modal.Header>
                    <Modal.Content>
                        <AddressTab 
                            relationId={_.toInteger(relationId)} 
                            addresses={addresses} 
                        />
                    </Modal.Content>
                </Modal>
            </div>
        );
    }
}

AddressSelector.propTypes = {
    name: PropTypes.string.isRequired,
    selectedValues: PropTypes.string.isRequired,
    onValueChange: PropTypes.func.isRequired,
    addresses: PropTypes.array.isRequired,
    relationId: PropTypes.string.isRequired
};

export default AddressSelector;


// WEBPACK FOOTER //
// ./src/components/utils/searches/AddressSelector.js